export default "__VITE_ASSET__Ck98jGoI__"